export default __webpack_public_path__ + "static/media/ic_order_session_selected.669e3f6e.svg";